<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
    <div class="bg-white rounded-lg p-6 w-3/4 max-w-4xl">
      <h3 class="text-lg font-semibold mb-2">Hilfsmittel</h3>
      <input v-model="deviceData.code" type="text" class="w-full p-2 border rounded mb-4" placeholder="Code (Pflichtfeld)" required>
      <input v-model="deviceData.display" type="text" class="w-full p-2 border rounded mb-4" placeholder="Anzeigename (Pflichtfeld)" required>
      <input v-model="deviceData.diagnosisICD" type="text" class="w-full p-2 border rounded mb-4" placeholder="Diagnose ICD">
      <input v-model="deviceData.diagnosisText" type="text" class="w-full p-2 border rounded mb-4" placeholder="Diagnosetext">
      <div class="flex space-x-4 mb-4">
        <input v-model="deviceData.verordnungszeitraumStart" type="date" class="w-1/2 p-2 border rounded" placeholder="Verordnungszeitraum Start">
        <input v-model="deviceData.verordnungszeitraumEnd" type="date" class="w-1/2 p-2 border rounded" placeholder="Verordnungszeitraum Ende">
      </div>
      <textarea v-model="deviceData.note" class="w-full p-2 border rounded mb-4" rows="3" placeholder="Bemerkung"></textarea>
      <div class="flex justify-end">
        <button @click="$emit('close')" class="mr-2 px-4 py-2 bg-gray-200 rounded">Abbrechen</button>
        <button @click="submit" class="px-4 py-2 bg-blue-500 text-white rounded">Übernehmen</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'DeviceModal',
  emits: ['close', 'submit'],
  setup(props, { emit }) {
    const deviceData = ref({
      code: '',
      display: '',
      diagnosisICD: '',
      diagnosisText: '',
      verordnungszeitraumStart: '',
      verordnungszeitraumEnd: '',
      note: ''
    });

    const submit = () => {
      if (deviceData.value.code && deviceData.value.display) {
        emit('submit', deviceData.value);
      } else {
        alert('Bitte füllen Sie die Pflichtfelder aus.');
      }
    };

    return {
      deviceData,
      submit
    };
  }
};
</script>